(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-anchor-nav"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var navSection = document.querySelector('.custom-anchor-nav-section');
    if (!navSection) return;

    var nav = navSection.querySelector('.custom-anchor-nav');
    if (!nav) return;

    var links = nav.querySelectorAll('.custom-anchor-nav__link');
    if (!links.length) return;

    var targets = [];
    links.forEach(function (link) {
      var id = link.getAttribute('data-anchor-target');
      if (id) {
        var el = document.getElementById(id);
        if (el) {
          // Scroll to the .shopify-section container, not the anchor point block
          var section = el.closest('.shopify-section');
          targets.push({ link: link, el: section || el });
        }
      }
    });

    if (!targets.length) return;

    // Find the sticky header (skip non-sticky elements like the top bar)
    var headerHeight = 0;
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function (el) {
      if (getComputedStyle(el).position === 'sticky') {
        headerHeight = el.offsetHeight;
      }
    });
    if (!headerHeight) headerHeight = 100; // fallback
    // Set CSS variable so sticky top position matches
    navSection.style.setProperty('--sticky-header-height', headerHeight + 'px');
    var navHeight = navSection.offsetHeight;
    var offset = headerHeight + navHeight;

    function onScroll() {
      var active = null;
      for (var i = targets.length - 1; i >= 0; i--) {
        if (targets[i].el.getBoundingClientRect().top <= offset + 20) {
          active = i;
          break;
        }
      }
      links.forEach(function (l) { l.classList.remove('is-active'); });
      if (active !== null) targets[active].link.classList.add('is-active');
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var id = this.getAttribute('data-anchor-target');
        var el = document.getElementById(id);
        if (el) {
          var section = el.closest('.shopify-section');
          var target = section || el;
          var targetTop = target.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: targetTop - offset,
            behavior: 'smooth'
          });
        }
      });
    });

    // Handle initial page load with hash fragment
    function scrollToHash() {
      var hash = window.location.hash.replace('#', '');
      if (!hash) return;
      var el = document.getElementById(hash);
      if (!el) return;
      var section = el.closest('.shopify-section');
      var target = section || el;
      var targetTop = target.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: targetTop - offset, behavior: 'smooth' });
    }

    // Delay to override native hash scroll
    if (window.location.hash) {
      window.scrollTo(0, 0);
      requestAnimationFrame(function () {
        requestAnimationFrame(scrollToHash);
      });
    }

    // Handle hash changes (e.g., back/forward navigation)
    window.addEventListener('hashchange', scrollToHash);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-coronavirus-locations"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var container = document.querySelector('.custom-coronavirus-locations');
    if (!container) return;

    var dataAttr = container.getAttribute('data-corona-blocks');
    if (!dataAttr) return;

    var coronaDataList;
    try {
      coronaDataList = JSON.parse(dataAttr);
    } catch (e) {
      return;
    }

    if (!coronaDataList || coronaDataList.length === 0) return;

    var urlParams = new URLSearchParams(window.location.search);
    var locationParam = urlParams.get('location');
    var scrollToBac = urlParams.get('scrollToBac');

    var locationData = getLocationData(locationParam);
    replaceContent(locationData);
    createDropdown('city', '[city-list]');
    createDropdown('state', '[state-list]');

    if (scrollToBac) {
      setTimeout(function() {
        var bacTarget = document.getElementById('average-bac');
        if (bacTarget) bacTarget.scrollIntoView();
      }, 500);
    }

    function getLocationData(paramValue) {
      var data = null;
      for (var i = 0; i < coronaDataList.length; i++) {
        if (coronaDataList[i].parameter === paramValue) {
          data = coronaDataList[i];
          break;
        }
      }
      if (!data) {
        for (var j = 0; j < coronaDataList.length; j++) {
          if (coronaDataList[j].parameter === 'california') {
            data = coronaDataList[j];
            break;
          }
        }
      }
      return data || {};
    }

    function replaceContent(data) {
      replaceTextInBody(/\[location\]/gi, data.location || '');
      replaceBullets(data);
      replaceFinePrint(data.fine_print);

      if (data.image_1) {
        replaceImage('[image-1]', data.image_1);
      } else {
        replaceTextInBody(/\[image-1\]/gi, '');
      }

      if (data.image_2) {
        replaceImage('[image-2]', data.image_2);
      } else {
        replaceTextInBody(/\[image-2\]/gi, '');
      }
    }

    function replaceBullets(data) {
      var bullets = [data.bullet_1, data.bullet_2, data.bullet_3, data.bullet_4, data.bullet_5];
      var filtered = [];
      for (var i = 0; i < bullets.length; i++) {
        if (bullets[i]) filtered.push(bullets[i]);
      }
      if (filtered.length) {
        var html = '<ul>';
        for (var j = 0; j < filtered.length; j++) {
          html += '<li>' + filtered[j] + '</li>';
        }
        html += '</ul>';
        replaceTextInBody(/\[bullets\]/gi, html);
      } else {
        replaceTextInBody(/\[bullets\]/gi, '');
      }
    }

    function replaceFinePrint(finePrint) {
      var html = finePrint ? '<p class="fine-print">' + finePrint + '</p>' : '';
      replaceTextInBody(/\[fine-print\]/gi, html);
    }

    function replaceImage(placeholder, imageUrl) {
      if (imageUrl) {
        var html = '<div class="max-view-image">'
          + '<a href="' + imageUrl + '" download target="_blank">'
          + '<img src="' + imageUrl + '" class="max-view-height" loading="lazy" />'
          + '</a><br>'
          + '<a href="' + imageUrl + '" download target="_blank">'
          + '<small>Download Hi-res Version</small>'
          + '</a></div>';
        var escaped = placeholder.replace(/[\[\]]/g, '\\$&');
        replaceTextInBody(new RegExp(escaped, 'gi'), html);
      } else {
        var escaped2 = placeholder.replace(/[\[\]]/g, '\\$&');
        replaceTextInBody(new RegExp(escaped2, 'gi'), '');
      }
    }

    function createDropdown(type, placeholder) {
      var items = [];
      for (var i = 0; i < coronaDataList.length; i++) {
        if (coronaDataList[i].type === type) items.push(coronaDataList[i]);
      }
      if (items.length === 0) return;

      var currentURL = window.location.protocol + '//' + window.location.host + window.location.pathname;
      var options = '';
      for (var j = 0; j < items.length; j++) {
        options += '<option value="' + currentURL + '?location=' + items[j].parameter + '&scrollToBac=true">' + items[j].location + '</option>';
      }

      var dropdownHtml = '<div class="' + type + '-list link-dropdown">'
        + '<select class="' + type + '-list-select select__select" id="' + type + '-list-select">'
        + '<option value="">Select ' + type + '</option>'
        + options
        + '</select></div>';

      var escaped = placeholder.replace(/[\[\]]/g, '\\$&');
      replaceTextInBody(new RegExp(escaped, 'gi'), dropdownHtml);

      setTimeout(function() {
        var select = document.getElementById(type + '-list-select');
        if (select) {
          select.addEventListener('change', function(event) {
            var url = event.target.value;
            if (url) window.location = url;
          });
        }
      }, 0);
    }

  function replaceTextInBody(oldText, newText) {
      var regex = oldText instanceof RegExp ? oldText : new RegExp(oldText, 'gi');
      var elements = document.body.getElementsByTagName('*');

      for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        var tagName = element.tagName.toLowerCase();
        if (tagName === 'script' || tagName === 'style' || tagName === 'template') continue;
        for (var j = 0; j < element.childNodes.length; j++) {
          var node = element.childNodes[j];
          if (node.nodeType === 3) {
            var text = node.nodeValue;
            var replacedText = text.replace(regex, newText);
            if (replacedText !== text) {
              var template = document.createElement('template');
              template.innerHTML = replacedText;
              if (element.tagName.toLowerCase() === 'p' && element.childNodes.length === 1 && text.trim().match(regex)) {
                element.replaceWith(template.content);
                break;
              } else {
                element.replaceChild(template.content, node);
                j--;
              }
            }
          }
        }
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-flipboxes"] && !Shopify.designMode) return;
  try {
    
  function initCustomFlipboxes() {
    var flipboxes = document.querySelectorAll('.custom-flipbox');
    var closeButtons = document.querySelectorAll('.custom-flipbox__close');

    closeButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var flipbox = button.closest('.custom-flipbox');
        if (flipbox) flipbox.classList.remove('hover');
      });
    });

    flipboxes.forEach(function(flipbox) {
      flipbox.addEventListener('mouseenter', function() {
        flipbox.classList.add('hover');
      });

      flipbox.addEventListener('mouseleave', function() {
        flipbox.classList.remove('hover');
      });

      flipbox.addEventListener('touchstart', function(e) {
        if (!e.target.closest('.custom-flipbox__close')) {
          flipbox.classList.add('hover');
        }
      }, { passive: true });

      flipbox.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          flipbox.classList.toggle('hover');
        } else if (e.key === 'Escape') {
          flipbox.classList.remove('hover');
        }
      });
    });
  }

  initCustomFlipboxes();

  document.addEventListener('shopify:section:load', initCustomFlipboxes);
  document.addEventListener('shopify:block:select', initCustomFlipboxes);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-footer-ad"]) return;
  try {
    
  /* BACtrack - Advertorial sticky CTA + telemetry (ported from store/view).

     Reads runtime state from <body> data-attributes (advertorial layout
     populates these from {{ article.* }} / advertorial metafields). All
     PostHog capture calls go through safeCapture() to defend against
     SDK-internal throws (consent-denied-after-stub-install, content-
     blocker partial blocking - optional chaining alone is insufficient). */
  (function () {
    var body = document.body;
    if (!body) return;

    /* Kill switch - bail before any observers, listeners, or storage I/O. */
    if (body.getAttribute('data-sticky-cta') === 'off') return;

    /* Per-session dismissal - bail without attaching the sticky bar
       handlers (scroll-depth + CTA delegation still attach below). */
    var dismissed = false;
    try {
      dismissed = sessionStorage.getItem('advertorial_sticky_dismissed') === '1';
    } catch (e) { /* private mode / storage blocked */ }

    var bar = document.getElementById('advertorial-sticky-cta');
    var articleHandle = body.dataset.articleHandle || '';
    var stickyLabelOverride = body.dataset.advertorialStickyLabel || '';

    /* Per-article CTA label override (metafield -> body data-attr). */
    if (bar && stickyLabelOverride) {
      var btn = bar.querySelector('.sticky-cta__button');
      if (btn) btn.textContent = stickyLabelOverride;
    }

    function safeCapture(name, props) {
      try {
        if (window.posthog && typeof window.posthog.capture === 'function') {
          window.posthog.capture(name, props || {});
        }
      } catch (e) { /* never throw from telemetry */ }
    }

    /* Bounded queue for NON-navigating events. PostHog arrives late (GTM
       loader, consent-gated), so events fired before window.posthog exists
       are held IF analytics consent is already granted at capture time
       (dropped otherwise), then flushed in order with their original
       timestamps. Polls 250ms x 40 (10s) like custom-posthog-bootstrap, then
       discards the queue. Click events never use this (page navigates away). */
    var QUEUE_MAX = 50;
    var QUEUE_POLL_MS = 250;
    var QUEUE_POLL_MAX = 40;
    var eventQueue = [];
    var queueTimer = null;
    var queuePolls = 0;
    var queueExpired = false;

    function posthogReady() {
      return !!(window.posthog && typeof window.posthog.capture === 'function');
    }

    function analyticsConsentGranted() {
      /* Shopify Customer Privacy API first; Pandectes cookie as fallback.
         Unresolved counts as NOT granted. GPC is a full denial, matching
         the ecommerce pixel's classifyConsent. */
      try {
        if (navigator.globalPrivacyControl === true) return false;
      } catch (eg) { /* ignore */ }
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
          return cp.analyticsProcessingAllowed() === true;
        }
      } catch (e) { /* fall through to cookie */ }
      try {
        var m = document.cookie.match(/(?:^|;\s*)_pandectes_gdpr=([^;]*)/);
        if (!m || !m[1]) return false;
        var raw = m[1];
        if (raw.indexOf('%') !== -1) {
          try { raw = decodeURIComponent(raw); } catch (e2) { /* keep raw */ }
        }
        raw = raw.replace(/-/g, '+').replace(/_/g, '/');
        var c = JSON.parse(atob(raw));
        if (!c || c.status !== 'allow') return false;
        /* preferences bitmask: bit1 (=2) is analytics, set means REJECTED. */
        var prefs = typeof c.preferences === 'number' ? c.preferences : null;
        return prefs === null || (prefs & 2) === 0;
      } catch (e3) {
        return false;
      }
    }

    function flushEventQueue() {
      var pending = eventQueue;
      eventQueue = [];
      for (var qi = 0; qi < pending.length; qi++) {
        try {
          window.posthog.capture(pending[qi].name, pending[qi].props, {
            timestamp: new Date(pending[qi].t)
          });
        } catch (e) { /* never throw from telemetry */ }
      }
    }

    function startQueuePoll() {
      if (queueTimer || queueExpired) return;
      queueTimer = setInterval(function () {
        queuePolls++;
        if (posthogReady()) {
          clearInterval(queueTimer);
          queueTimer = null;
          flushEventQueue();
        } else if (queuePolls >= QUEUE_POLL_MAX) {
          clearInterval(queueTimer);
          queueTimer = null;
          queueExpired = true;
          eventQueue = [];
        }
      }, QUEUE_POLL_MS);
    }

    function queueCapture(name, props) {
      try {
        if (posthogReady()) {
          if (eventQueue.length) flushEventQueue();
          window.posthog.capture(name, props || {});
          return;
        }
        if (queueExpired || eventQueue.length >= QUEUE_MAX) return;
        if (!analyticsConsentGranted()) return;
        eventQueue.push({ name: name, props: props || {}, t: Date.now() });
        startQueuePoll();
      } catch (e) { /* never throw from telemetry */ }
    }

    function pushDataLayer(event, props) {
      try {
        window.dataLayer = window.dataLayer || [];
        var payload = { event: event };
        if (props) {
          for (var k in props) {
            if (Object.prototype.hasOwnProperty.call(props, k)) payload[k] = props[k];
          }
        }
        window.dataLayer.push(payload);
      } catch (e) { /* never throw from telemetry */ }
    }

    /* --- INBOUND ATTRIBUTION FORWARDING (bactrack.com variant) -----
       CTAs in the article body ship with the organic default
       utm_source=advertorial / utm_medium=advertorial / utm_campaign=
       {handle} / utm_content={placement}. When a reader arrives from a
       Meta / Google / TikTok ad, the inbound URL carries that platform's
       own parameters. This block rewrites every advertorial CTA href at
       page load:
         1. Lifts the advertorial fingerprint to dedicated `advertorial=`
            + `placement=` params so it survives whatever the ad brings.
         2. If the inbound URL carries utm_source, drops the baked organic
            utm_* and forwards EVERY inbound `utm_*` and `tw_*` parameter
            verbatim, whatever its key. The View original forwarded a fixed
            list of five keys; here the campaign's `utm_id=c6lp` has to
            reach the landing page byte for byte because Aftersell's
            "LP C6 x1" funnel matches it as exact text from the storefront
            session. An unknown key is forwarded, never dropped.
         3. Always forwards the platform click ids (gclid / fbclid /
            msclkid / ttclid / gbraid / wbraid) regardless of utm state.
       No /discount/ hop and no direct-to-checkout link: the landing page
       applies its own code and Aftersell needs the storefront visit.
       Scope is limited to .bactrack.com hostnames. */
    var inboundParams = new URLSearchParams(window.location.search);
    var INBOUND_CLICKID_KEYS = ['gclid', 'fbclid', 'msclkid', 'ttclid', 'gbraid', 'wbraid'];

    function rewriteAdvertorialHref(anchor) {
      var originalHref = anchor.getAttribute('href') || '';
      try {
        var url = new URL(originalHref, window.location.origin);
        if (!/(^|\.)bactrack\.com$/.test(url.hostname)) return;

        var advertorialId = articleHandle ||
                            url.searchParams.get('utm_campaign') || '';
        var placement = anchor.getAttribute('data-cta-placement') ||
                        url.searchParams.get('utm_content') || '';
        if (advertorialId) url.searchParams.set('advertorial', advertorialId);
        if (placement)     url.searchParams.set('placement', placement);

        if (inboundParams.has('utm_source')) {
          /* Atomic replacement: no mixed-source utm_* state. */
          var baked = [];
          url.searchParams.forEach(function (v, k) {
            if (k.indexOf('utm_') === 0) baked.push(k);
          });
          for (var b = 0; b < baked.length; b++) url.searchParams.delete(baked[b]);
          inboundParams.forEach(function (v, k) {
            if (k.indexOf('utm_') === 0 || k.indexOf('tw_') === 0) {
              if (v != null && v !== '') url.searchParams.set(k, v);
            }
          });
        } else {
          /* No inbound UTMs (organic / direct / email) - synthesize the
             advertorial bucket so the landing page still sees the source. */
          url.searchParams.set('utm_source', 'advertorial');
          url.searchParams.set('utm_medium', 'advertorial');
          if (advertorialId) url.searchParams.set('utm_campaign', advertorialId);
          if (placement)     url.searchParams.set('utm_content', placement);
        }

        INBOUND_CLICKID_KEYS.forEach(function (key) {
          var v = inboundParams.get(key);
          if (v != null && v !== '') url.searchParams.set(key, v);
        });

        anchor.setAttribute('href', url.toString());
      } catch (e) { /* invalid URL - leave hardcoded href as-is */ }
    }

    /* Section JS loads deferred per Horizon convention - DOM is parsed
       and both the article body and sticky bar are present by now. */
    var ctaSelector = '.advertorial-article a[href], .sticky-cta a[href]';
    var ctaAnchors = document.querySelectorAll(ctaSelector);
    for (var i = 0; i < ctaAnchors.length; i++) {
      rewriteAdvertorialHref(ctaAnchors[i]);
    }

    /* --- STICKY BAR (skip when bar absent or dismissed this session) -- */
    if (bar && !dismissed) {
      bar.removeAttribute('hidden');

      var stickyVisible = false;
      var stickyViewCaptured = false;
      var heroOutOfView = false;
      var finalCtaInView = false;

      function showSticky() {
        if (stickyVisible) return;
        stickyVisible = true;
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
        /* Restore focusability when bar enters tab order. */
        bar.querySelectorAll('[tabindex="-1"]').forEach(function (el) {
          el.removeAttribute('tabindex');
        });
        if (!stickyViewCaptured) {
          stickyViewCaptured = true;
          queueCapture('advertorial_sticky_view', {
            article_handle: articleHandle,
            cta_placement: 'sticky-bar'
          });
        }
      }

      function hideSticky() {
        if (!stickyVisible) return;
        stickyVisible = false;
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
        /* Remove from tab order while visually hidden. */
        bar.querySelector('.sticky-cta__button').setAttribute('tabindex', '-1');
        bar.querySelector('.sticky-cta__dismiss').setAttribute('tabindex', '-1');
      }

      function reconcile() {
        if (finalCtaInView) hideSticky();
        else if (heroOutOfView) showSticky();
        else hideSticky();
      }

      if ('IntersectionObserver' in window) {
        var hero = document.querySelector('[data-advertorial-hero]');
        if (hero) {
          /* Show sticky once hero is at least 50% scrolled out of viewport. */
          new IntersectionObserver(function (entries) {
            heroOutOfView = !entries[0].isIntersecting;
            reconcile();
          }, { rootMargin: '0px 0px -50% 0px', threshold: 0 }).observe(hero);
        }

        var finalCta = document.querySelector('[data-advertorial-final-cta]');
        if (finalCta) {
          /* Hide sticky when final CTA card is 30% in view (no competition). */
          new IntersectionObserver(function (entries) {
            finalCtaInView = entries[0].isIntersecting;
            reconcile();
          }, { threshold: 0.3 }).observe(finalCta);
        }
      }

      /* Sticky CTA click -> telemetry + native navigation. */
      var stickyButton = bar.querySelector('.sticky-cta__button');
      if (stickyButton) {
        stickyButton.addEventListener('click', function () {
          safeCapture('advertorial_sticky_click', {
            article_handle: articleHandle,
            cta_placement: 'sticky-bar',
            cta_label: stickyButton.textContent
          });
          pushDataLayer('advertorial_cta_click', {
            cta_placement: 'sticky-bar',
            cta_label: stickyButton.textContent,
            article_handle: articleHandle
          });
        });
      }

      /* Dismiss x -> hide for the session. */
      var dismissButton = bar.querySelector('.sticky-cta__dismiss');
      if (dismissButton) {
        dismissButton.addEventListener('click', function () {
          hideSticky();
          try {
            sessionStorage.setItem('advertorial_sticky_dismissed', '1');
          } catch (e) { /* private mode - sticky just won't persist */ }
          queueCapture('advertorial_sticky_dismiss', {
            article_handle: articleHandle,
            cta_placement: 'sticky-bar'
          });
        });
      }
    }

    /* --- SCROLL DEPTH (25/50/75/100) ------------------------------------ */
    var scrollThresholds = [25, 50, 75, 100];
    var scrollFired = {};
    var scrollScheduled = false;

    var maxDepth = 0;

    function currentDepth() {
      var docH = document.documentElement.scrollHeight || document.body.scrollHeight;
      if (!docH) return 0;
      /* +2px: fractional scroll offsets otherwise cap at ~99.99 and the
         100 threshold never fires at the true bottom of the page. */
      return Math.min(100, ((window.scrollY + window.innerHeight + 2) / docH) * 100);
    }

    function updateMaxDepth() {
      var d = currentDepth();
      if (d > maxDepth) maxDepth = d;
    }

    function checkScrollDepth() {
      scrollScheduled = false;
      var depth = currentDepth();
      if (depth > maxDepth) maxDepth = depth;
      for (var i = 0; i < scrollThresholds.length; i++) {
        var t = scrollThresholds[i];
        if (!scrollFired[t] && depth >= t) {
          scrollFired[t] = true;
          queueCapture('advertorial_scroll_depth', {
            depth: t,
            article_handle: articleHandle
          });
        }
      }
    }
    window.addEventListener('scroll', function () {
      if (scrollScheduled) return;
      scrollScheduled = true;
      window.requestAnimationFrame(checkScrollDepth);
    }, { passive: true });


    /* --- BODY CTA VIEW (once per anchor at >= 50% visible) ------------ */
    if ('IntersectionObserver' in window) {
      var ctaViewAnchors = document.querySelectorAll('a[data-cta-placement]');
      var ctaViewObserver = new IntersectionObserver(function (entries) {
        for (var ei = 0; ei < entries.length; ei++) {
          if (!entries[ei].isIntersecting) continue;
          var el = entries[ei].target;
          ctaViewObserver.unobserve(el);
          queueCapture('advertorial_cta_view', {
            article_handle: articleHandle,
            cta_placement: el.getAttribute('data-cta-placement') || 'inline',
            cta_label: (el.textContent || '').trim().slice(0, 80),
            cta_href: el.getAttribute('href') || ''
          });
        }
      }, { threshold: 0.5 });
      for (var vi = 0; vi < ctaViewAnchors.length; vi++) {
        if (ctaViewAnchors[vi].closest && ctaViewAnchors[vi].closest('.sticky-cta')) continue;
        ctaViewObserver.observe(ctaViewAnchors[vi]);
      }
    }

    /* --- ENGAGEMENT (max depth + visible seconds, sent once) ---------- */
    var engagedMs = 0;
    var visibleSince = document.visibilityState === 'visible' ? Date.now() : 0;
    var engagementSent = false;

    function onVisibilityForEngagement() {
      if (document.visibilityState === 'visible') {
        if (!visibleSince) visibleSince = Date.now();
      } else if (visibleSince) {
        engagedMs += Date.now() - visibleSince;
        visibleSince = 0;
      }
    }
    document.addEventListener('visibilitychange', onVisibilityForEngagement);

    function sendEngagement() {
      if (engagementSent) return;
      engagementSent = true;
      try {
        if (visibleSince) {
          engagedMs += Date.now() - visibleSince;
          visibleSince = 0;
        }
        updateMaxDepth();
        if (posthogReady()) {
          window.posthog.capture('advertorial_engagement', {
            article_handle: articleHandle,
            max_depth: Math.min(100, Math.round(maxDepth)),
            engaged_seconds: Math.round(engagedMs / 1000)
          }, { send_instantly: true, transport: 'sendBeacon' });
        }
      } catch (e) { /* never throw from telemetry */ }
    }
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') sendEngagement();
    });
    window.addEventListener('pagehide', sendEngagement);

    /* --- ARTICLE-BODY CTA DELEGATION ---------------------------------
       Every bactrack.com link in the article body fires
       advertorial_cta_click with placement read from the link's
       data-cta-placement attribute (set in U6 article body HTML). */
    document.addEventListener('click', function (event) {
      var target = event.target;
      while (target && target !== document) {
        if (target.tagName === 'A') break;
        target = target.parentNode;
      }
      if (!target || target.tagName !== 'A') return;
      var href = target.getAttribute('href') || '';
      if (href.indexOf('bactrack.com') === -1) return;

      /* Skip the sticky-bar link - it has its own handler above. */
      if (target.closest && target.closest('.sticky-cta')) return;

      var placement = target.getAttribute('data-cta-placement') || 'inline';
      var label = (target.textContent || '').trim().slice(0, 80);
      safeCapture('advertorial_cta_click', {
        article_handle: articleHandle,
        cta_placement: placement,
        cta_label: label,
        cta_href: href
      });
      pushDataLayer('advertorial_cta_click', {
        cta_placement: placement,
        cta_label: label,
        article_handle: articleHandle
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header-ad"]) return;
  try {
    
  /* Header section has no JS - block reserved so future additions don't
     trigger Shopify's silent schema-drop on first push of a new javascript
     block. See docs/solutions/integration-issues/shopify-theme-push-drops-
     new-block-setting-2026-04-20.md */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-media-images"]) return;
  try {
    
  class CustomMediaDrawer extends HTMLElement {
    constructor() {
      super();
      this.panel = this.querySelector('.custom-media-drawer__panel');
      this.closeButton = this.querySelector('.custom-media-drawer__close');
      this.overlay = this.querySelector('.custom-media-drawer__overlay');

      var section = this.closest('.shopify-section');
      this.mediaGroup = section ? section.querySelector('.custom-media-group') : null;

      if (this.overlay) {
        this.overlay.addEventListener('click', this.close.bind(this));
      }
      if (this.closeButton) {
        this.closeButton.addEventListener('click', this.close.bind(this));
      }
      if (this.mediaGroup) {
        this.mediaGroup.addEventListener('click', this.open.bind(this));
        this.mediaGroup.addEventListener('keydown', function(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.open();
          }
        }.bind(this));
      }

      this.addEventListener('keyup', function(event) {
        if (event.code === 'Escape') {
          this.close();
        }
      }.bind(this));
    }

    open() {
      this.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
      if (this.closeButton) {
        this.closeButton.focus();
      }
    }

    close() {
      this.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      if (this.mediaGroup) {
        this.mediaGroup.focus();
      }
    }
  }

  customElements.define('custom-media-drawer', CustomMediaDrawer);

  function initCustomMediaGroups() {
    var sections = document.querySelectorAll('.shopify-section:has(.custom-media-group)');
    if (sections.length === 0) return;

    var container = document.querySelector('.custom-media-groups');
    if (!container) {
      container = document.createElement('div');
      container.className = 'custom-media-groups';
      sections[0].parentNode.insertBefore(container, sections[0]);
    }

    sections.forEach(function(section) {
      if (!section.parentNode.classList.contains('custom-media-groups')) {
        container.appendChild(section);
      }
    });
  }

  initCustomMediaGroups();

  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.custom-media-group')) {
      initCustomMediaGroups();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-page-reviews"]) return;
  try {
    
  function formatReviewLocation(location) {
    if (!location) return '';
    var parts = location.split(',');
    var trimmed = [];
    var seen = {};
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].replace(/^\s+|\s+$/g, '');
      if (p && !seen[p]) {
        seen[p] = true;
        trimmed.push(p);
      }
    }
    if (trimmed.length === 0) return '';
    return ' from ' + trimmed.join(', ');
  }

  function customReviewStars(value) {
    var rating = parseFloat(value) || 0;
    if (rating < 0) rating = 0;
    if (rating > 5) rating = 5;
    var markup = '';
    for (var s = 0; s < 5; s++) {
      var pct = Math.max(0, Math.min(100, (rating - s) * 100));
      var bucket = 0;
      if (pct >= 87.5) bucket = 100;
      else if (pct >= 62.5) bucket = 75;
      else if (pct >= 37.5) bucket = 50;
      else if (pct >= 12.5) bucket = 25;
      markup += '<i class="ruk-icon-percentage-star--' + bucket + '"></i>';
    }
    return '<span class="custom-rating-stars" aria-hidden="true">' + markup + '</span>';
  }

  var reviewBlocks = document.querySelectorAll('[data-json-reviews]');
  if (reviewBlocks.length) {
    reviewBlocks.forEach(function(block) {
      var url = block.dataset.jsonReviews;
      if (!url) {
        block.innerHTML = '<p>Reviews coming soon.</p>';
        return;
      }

      fetch(url, { headers: { 'accept': 'application/json' } })
        .then(function(response) { return response.json(); })
        .then(function(data) {
          if (!data.reviews || data.reviews.length === 0) {
            block.innerHTML = '<p>Reviews coming soon.</p>';
            return;
          }

          var html = '';
          data.reviews.forEach(function(review) {
            var rating = customReviewStars(review.rating);
            var name = (review.author && review.author.name) ? review.author.name : 'Verified Reviewer';
            var loc = formatReviewLocation(review.author && review.author.location ? review.author.location : '');

            html += '<div class="custom-page-reviews__review">'
              + '<div class="custom-page-reviews__review-rating">' + rating + '</div>'
              + (review.title ? '<h3 class="custom-page-reviews__review-headline">' + review.title + '</h3>' : '')
              + '<p class="custom-page-reviews__review-comments">' + review.comments + '</p>'
              + '<p class="custom-page-reviews__review-reviewer">'
              + name + loc
              + (review.verified ? ' <span class="custom-page-reviews__review-verified">Verified Buyer</span>' : '')
              + '</p>'
              + '</div>';
          });

          block.innerHTML = html || '<p>Reviews coming soon.</p>';
        })
        .catch(function(error) {
          console.error('Error fetching reviews:', error);
          block.innerHTML = '<p>Reviews coming soon.</p>';
        });
    });
  }

  var customReviewsMenu = document.querySelector('.custom-page-reviews__menu');
  if (customReviewsMenu) {
    var syncReviewsStickyOffsets = function() {
      var root = document.documentElement;
      var headerH = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height'), 10) || 0;
      root.style.setProperty('--cpr-header-h', headerH + 'px');
      root.style.setProperty('--custom-reviews-menu-height', customReviewsMenu.offsetHeight + 'px');
      // Override the global html{scroll-padding-top} (set for article anchors,
      // a fixed value) with the real header height so anchor jumps to products
      // land at header + menu + gap, not header + that fixed value + menu.
      root.style.scrollPaddingTop = headerH + 'px';
    };
    syncReviewsStickyOffsets();
    window.addEventListener('resize', syncReviewsStickyOffsets);
    window.addEventListener('load', syncReviewsStickyOffsets);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-calibration"]) return;
  try {
    
  var section = document.querySelector('[data-calibration-section]');
  if (!section) return;

  var dataEl = section.querySelector('[data-variant-data]');
  if (!dataEl) return;

  var variants;
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var variantIdInput = section.querySelector('[data-variant-id]');
  var quantityInput = section.querySelector('[data-quantity]');
  var priceEl = section.querySelector('[data-price]');
  var comparePriceEl = section.querySelector('[data-compare-price]');
  var addToCartBtn = section.querySelector('[data-add-to-cart]');
  var soldoutMsg = section.querySelector('[data-soldout-message]');
  var mediaContainer = section.querySelector('[data-calibration-media]');
  var isSubmitting = false;

  var optionInputs = section.querySelectorAll('input[data-option-position]');
  for (var i = 0; i < optionInputs.length; i++) {
    optionInputs[i].addEventListener('change', handleOptionChange);
  }

  var modelSelect = section.querySelector('[data-model-select]');
  if (modelSelect) {
    modelSelect.addEventListener('change', function() {
      for (var i = 0; i < optionInputs.length; i++) {
        if (optionInputs[i].getAttribute('data-option-position') === '1' && optionInputs[i].value === this.value) {
          optionInputs[i].checked = true;
          optionInputs[i].dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
    });
  }

  var requiredInputs = section.querySelectorAll('.custom-calibration__input[data-required="true"]');
  for (var r = 0; r < requiredInputs.length; r++) {
    requiredInputs[r].addEventListener('input', handleFieldInput);
    requiredInputs[r].addEventListener('change', handleFieldInput);
  }

  var multiInputs = section.querySelectorAll('[data-multi-input]');
  for (var m = 0; m < multiInputs.length; m++) {
    multiInputs[m].addEventListener('input', handleMultiInput);
  }

  var tooltipButtons = section.querySelectorAll('[data-tooltip-toggle]');
  for (var t = 0; t < tooltipButtons.length; t++) {
    tooltipButtons[t].addEventListener('click', handleTooltipToggle);
  }

  document.addEventListener('click', function(event) {
    if (!section.contains(event.target)) {
      closeTooltips();
      return;
    }

    if (!event.target.closest('[data-tooltip-toggle]')) {
      closeTooltips();
    }
  });

  function handleOptionChange() {
    var fieldset = this.closest('fieldset');
    if (fieldset) {
      var pills = fieldset.querySelectorAll('.custom-calibration__pill');
      for (var p = 0; p < pills.length; p++) {
        pills[p].classList.remove('custom-calibration__pill--selected');
      }
      var pill = this.closest('.custom-calibration__pill');
      if (pill) pill.classList.add('custom-calibration__pill--selected');
    }

    if (modelSelect && this.getAttribute('data-option-position') === '1') {
      modelSelect.value = this.value;
    }

    var variant = findCurrentVariant();
    if (variant) updateVariant(variant);
  }

  function findCurrentVariant() {
    var selected = section.querySelectorAll('input[data-option-position]:checked');
    var opts = {};
    for (var i = 0; i < selected.length; i++) {
      opts['option' + selected[i].getAttribute('data-option-position')] = selected[i].value;
    }

    for (var j = 0; j < variants.length; j++) {
      var v = variants[j];
      var match = true;
      for (var key in opts) {
        if (opts.hasOwnProperty(key) && v[key] !== opts[key]) {
          match = false;
          break;
        }
      }
      if (match) return v;
    }
    return null;
  }

  function updateVariant(variant) {
    if (variantIdInput) variantIdInput.value = variant.id;

    if (priceEl) priceEl.textContent = variant.price;

    if (variant.compare_at_price) {
      if (!comparePriceEl) {
        var s = document.createElement('s');
        s.className = 'custom-calibration__price-compare';
        s.setAttribute('data-compare-price', '');
        var priceContainer = section.querySelector('[data-calibration-price]');
        if (priceContainer) priceContainer.appendChild(s);
        comparePriceEl = s;
      }
      comparePriceEl.textContent = variant.compare_at_price;
      comparePriceEl.style.display = '';
    } else if (comparePriceEl) {
      comparePriceEl.style.display = 'none';
    }

    if (addToCartBtn) addToCartBtn.setAttribute('data-variant-available', variant.available ? 'true' : 'false');

    if (soldoutMsg) {
      soldoutMsg.style.display = variant.available ? 'none' : '';
    }

    if (mediaContainer && variant.featured_media_id) {
      var items = mediaContainer.querySelectorAll('.custom-calibration__media-item');
      for (var i = 0; i < items.length; i++) {
        var mid = parseInt(items[i].getAttribute('data-media-id'), 10);
        items[i].style.display = (mid === variant.featured_media_id) ? '' : 'none';
      }
    }

    var url = window.location.pathname + '?variant=' + variant.id;
    window.history.replaceState({}, '', url);
    updateFormState();
  }

  function handleFieldInput() {
    updateFormState();
  }

  function handleMultiInput() {
    var group = this.closest('[data-field-group]');
    if (group) syncMergedValues(group, true);
    updateAddMoreState(group);
    updateFormState();
  }

  function handleTooltipToggle(event) {
    event.stopPropagation();
    var isOpen = this.getAttribute('aria-expanded') === 'true';
    closeTooltips();
    this.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
  }

  function closeTooltips() {
    for (var i = 0; i < tooltipButtons.length; i++) {
      tooltipButtons[i].setAttribute('aria-expanded', 'false');
    }
  }

  var addMoreBtns = section.querySelectorAll('[data-add-more]');
  for (var a = 0; a < addMoreBtns.length; a++) {
    addMoreBtns[a].addEventListener('click', handleAddMore);
  }

  function handleAddMore() {
    var group = this.closest('[data-field-group]');
    if (!group) return;

    var input = group.querySelector('[data-multi-input]');
    if (!input || !input.value.trim()) return;

    var container = group.querySelector('[data-multi-entries]');
    if (!container) return;

    var val = input.value.trim();

    var entry = document.createElement('div');
    entry.className = 'custom-calibration__entry';

    var text = document.createElement('span');
    text.className = 'custom-calibration__entry-text';
    text.textContent = val;

    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'custom-calibration__entry-remove';
    removeBtn.setAttribute('aria-label', 'Remove ' + val);
    removeBtn.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';

    var g = group;
    removeBtn.addEventListener('click', function() {
      entry.remove();
      syncMergedValues(g);
    });

    entry.appendChild(text);
    entry.appendChild(removeBtn);
    container.appendChild(entry);

    input.value = '';
    input.focus();
    syncMergedValues(group, false);
    updateAddMoreState(group);
    updateFormState();
  }

  function syncMergedValues(group, includeCurrentInput) {
    var entries = group.querySelectorAll('.custom-calibration__entry-text');
    var merged = group.querySelector('[data-merged-values]');
    if (!merged) return;

    var vals = [];
    for (var i = 0; i < entries.length; i++) {
      vals.push(entries[i].textContent);
    }

    var input = group.querySelector('[data-multi-input]');
    if (includeCurrentInput && input && input.value.trim()) {
      vals.push(input.value.trim());
    }

    merged.value = vals.join(', ');

    if (quantityInput) {
      quantityInput.value = Math.max(1, vals.length);
    }
  }

  function updateAddMoreState(group) {
    if (!group) return;

    var input = group.querySelector('[data-multi-input]');
    var button = group.querySelector('[data-add-more]');
    if (!input || !button) return;

    button.disabled = !input.value.trim();
  }

  function getMultiValues(group, includeCurrentInput) {
    var values = [];
    var entries = group.querySelectorAll('.custom-calibration__entry-text');
    for (var i = 0; i < entries.length; i++) {
      values.push(entries[i].textContent);
    }

    var input = group.querySelector('[data-multi-input]');
    if (includeCurrentInput && input && input.value.trim()) values.push(input.value.trim());
    return values;
  }

  function isFormComplete() {
    for (var i = 0; i < requiredInputs.length; i++) {
      var input = requiredInputs[i];
      if (input.hasAttribute('data-multi-input')) {
        var group = input.closest('[data-field-group]');
        if (!group || getMultiValues(group, true).length === 0) return false;
      } else if (!input.value.trim()) {
        return false;
      }
    }

    return true;
  }

  function updateFormState() {
    if (!addToCartBtn) return;

    for (var i = 0; i < multiInputs.length; i++) {
      var group = multiInputs[i].closest('[data-field-group]');
      if (group) {
        syncMergedValues(group, true);
        updateAddMoreState(group);
      }
    }

    var variantAvailable = addToCartBtn.getAttribute('data-variant-available') === 'true';
    var canSubmit = variantAvailable && isFormComplete();
    addToCartBtn.disabled = !canSubmit;
    addToCartBtn.setAttribute('aria-disabled', canSubmit ? 'false' : 'true');
    addToCartBtn.textContent = variantAvailable ? 'Add to Cart' : 'Sold Out';
  }

  var form = section.querySelector('form');
  if (form) {
    form.addEventListener('submit', function(event) {
      event.preventDefault();
      updateFormState();
      if (addToCartBtn && addToCartBtn.disabled) {
        if (form.reportValidity) form.reportValidity();
        return;
      }

      for (var i = 0; i < multiInputs.length; i++) {
        var group = multiInputs[i].closest('[data-field-group]');
        if (group) syncMergedValues(group, true);
      }

      submitToCart();
    });
  }

  function getCartSectionIds() {
    var ids = [];
    var cartItems = document.querySelectorAll('cart-items-component');
    for (var i = 0; i < cartItems.length; i++) {
      if (cartItems[i].dataset.sectionId && ids.indexOf(cartItems[i].dataset.sectionId) === -1) {
        ids.push(cartItems[i].dataset.sectionId);
      }
    }
    return ids;
  }

  function getRoute(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return root.replace(/\/$/, '') + path;
  }

  function submitToCart() {
    if (isSubmitting || !form || !addToCartBtn) return;

    isSubmitting = true;
    addToCartBtn.disabled = true;
    addToCartBtn.setAttribute('aria-disabled', 'true');

    var formData = new FormData(form);
    var sectionIds = getCartSectionIds();
    if (sectionIds.length > 0) {
      formData.append('sections', sectionIds.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    fetch(getRoute('/cart/add.js'), {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: formData
    })
      .then(function(response) {
        return response.json().then(function(data) {
          if (!response.ok || data.status) throw data;
          return data;
        });
      })
      .then(function(response) {
        return fetch(getRoute('/cart.js')).then(function(cartResponse) {
          return cartResponse.json().then(function(cart) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: form.id,
                data: {
                  source: 'product-form-component',
                  itemCount: Number(formData.get('quantity')) || 1,
                  variantId: String(formData.get('id') || ''),
                  sections: response.sections || {}
                }
              }
            }));
          });
        });
      })
      .catch(function(error) {
        console.error(error);
      })
      .finally(function() {
        isSubmitting = false;
        updateFormState();
      });
  }

  updateFormState();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-comparison"]) return;
  try {
    
  /* Comparison Drawer */
  class CustomComparisonDrawer extends HTMLElement {
    constructor() {
      super();
      var self = this;
      this.overlay = this.querySelector('.custom-comparison-drawer__overlay');
      this.panel = this.querySelector('.custom-comparison-drawer__panel');
      this.closeBtn = this.querySelector('.custom-comparison-drawer__close');
      this.compareBtn = this.querySelector('[data-action="compare"]');
      this.activeElement = null;
      this._focusTrapCleanup = null;

      if (this.overlay) {
        this.overlay.addEventListener('click', function() { self.close(); });
      }
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', function() { self.close(); });
      }
      if (this.compareBtn) {
        this.compareBtn.addEventListener('click', function() { self.compare(); });
      }
      this.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') self.close();
      });
    }

    connectedCallback() {
      if (this.parentElement && this.parentElement !== document.body) {
        document.body.appendChild(this);
      }
    }

    open(trigger) {
      if (trigger) this.activeElement = trigger;
      this.classList.add('active');
      this.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      var self = this;
      setTimeout(function() {
        if (self.panel) {
          self._focusTrapCleanup = trapComparisonFocus(self.panel, self.panel);
        }
      }, 300);
    }

    close() {
      this.classList.remove('active');
      this.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (this._focusTrapCleanup) {
        this._focusTrapCleanup();
        this._focusTrapCleanup = null;
      }
      if (this.activeElement) {
        this.activeElement.focus();
        this.activeElement = null;
      }
    }

    compare() {
      var checked = this.querySelectorAll('input[data-compare-id]:checked');
      var ids = [];
      for (var i = 0; i < checked.length; i++) {
        ids.push(checked[i].value);
      }

      var table = document.querySelector('custom-comparison-table');
      if (table) {
        if (ids.length > 0) {
          table.showProducts(ids);
          try { localStorage.setItem('compareList', JSON.stringify(ids)); } catch (e) { /* noop */ }
        } else {
          table.showAllProducts();
          try { localStorage.removeItem('compareList'); } catch (e) { /* noop */ }
        }
      }
      this.close();
    }

    syncCheckboxes(productIds) {
      var inputs = this.querySelectorAll('input[data-compare-id]');
      for (var i = 0; i < inputs.length; i++) {
        inputs[i].checked = productIds.indexOf(inputs[i].value) !== -1;
      }
    }
  }
  customElements.define('custom-comparison-drawer', CustomComparisonDrawer);

  /* Comparison Table */
  class CustomComparisonTable extends HTMLElement {
    constructor() {
      super();
      this.chartWrapper = this.querySelector('[data-chart-wrapper]');
      this.modifyBtn = this.querySelector('[data-action="open-drawer"]');
      this.cells = null;
      this.productCellMap = null;
    }

    connectedCallback() {
      this.buildCellMap();
      this.init();
      this.bindEvents();
      this.setupModifyStickyState();
    }

    // Drop the Modify bar's shadow once it reaches its resting spot at the
    // bottom of the table (sentinel visible == resting, hidden == floating).
    setupModifyStickyState() {
      var bar = this.querySelector('.custom-comparison__modify-bar');
      var sentinel = this.querySelector('.custom-comparison__modify-sentinel');
      if (!bar || !sentinel) return;
      if (!('IntersectionObserver' in window)) {
        bar.classList.add('is-floating');
        return;
      }
      var observer = new IntersectionObserver(function(entries) {
        for (var i = 0; i < entries.length; i++) {
          bar.classList.toggle('is-floating', !entries[i].isIntersecting);
        }
      }, { threshold: 0 });
      observer.observe(sentinel);
    }

    buildCellMap() {
      var allCells = this.querySelectorAll('td[data-product-id], th[data-product-id]');
      this.cells = allCells;
      this.productCellMap = {};
      for (var i = 0; i < allCells.length; i++) {
        var id = allCells[i].getAttribute('data-product-id');
        if (!this.productCellMap[id]) this.productCellMap[id] = [];
        this.productCellMap[id].push(allCells[i]);
      }
    }

    init() {
      var urlParams = new URLSearchParams(window.location.search);
      var pids = urlParams.get('pids');

      if (pids === 'all') {
        this.showAllProducts();
      } else if (pids) {
        var ids = pids.split(',');
        try { localStorage.setItem('compareList', JSON.stringify(ids)); } catch (e) { /* noop */ }
        this.showProducts(ids);
      } else {
        var stored = this.getStoredList();
        if (stored.length > 0) {
          this.showProducts(stored);
        } else {
          this.showAllProducts();
        }
      }

      // Sync drawer checkboxes with the saved selection (not the visible
      // columns) so unchecking everything is remembered: with no saved
      // selection the chart shows all but the drawer shows none checked.
      var drawer = document.querySelector('custom-comparison-drawer');
      if (drawer) {
        drawer.syncCheckboxes(this.getStoredList());
      }

      // Reveal chart
      if (this.chartWrapper) {
        this.chartWrapper.style.visibility = 'visible';
      }
    }

    bindEvents() {
      var self = this;
      if (this.modifyBtn) {
        this.modifyBtn.addEventListener('click', function() {
          var drawer = document.querySelector('custom-comparison-drawer');
          if (drawer) {
            drawer.syncCheckboxes(self.getStoredList());
            drawer.open(self.modifyBtn);
          }
        });
      }
    }

    showProducts(productIds) {
      for (var i = 0; i < this.cells.length; i++) {
        this.cells[i].style.display = 'none';
      }
      for (var j = 0; j < productIds.length; j++) {
        var id = String(productIds[j]).replace(/["\[\]\s]/g, '');
        var cells = this.productCellMap[id];
        if (cells) {
          for (var k = 0; k < cells.length; k++) {
            cells[k].style.display = 'table-cell';
          }
        }
      }
    }

    showAllProducts() {
      for (var i = 0; i < this.cells.length; i++) {
        this.cells[i].style.display = 'table-cell';
      }
    }

    getActiveProductIds() {
      var ids = [];
      var headers = this.querySelectorAll('.custom-comparison__header-row th[data-product-id]');
      for (var i = 0; i < headers.length; i++) {
        if (headers[i].style.display !== 'none') {
          ids.push(headers[i].getAttribute('data-product-id'));
        }
      }
      return ids;
    }

    getStoredList() {
      try {
        var stored = localStorage.getItem('compareList');
        if (stored) {
          var parsed = JSON.parse(stored);
          if (Array.isArray(parsed)) return parsed;
        }
      } catch (e) { /* noop */ }
      return [];
    }
  }
  customElements.define('custom-comparison-table', CustomComparisonTable);

  /* Focus trap */
  function trapComparisonFocus(container, focusElement) {
    var focusable = container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]'
    );
    if (focusable.length === 0) return function() {};

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    function handleKeyDown(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    container.addEventListener('keydown', handleKeyDown);
    if (focusElement) focusElement.focus();

    return function() {
      container.removeEventListener('keydown', handleKeyDown);
    };
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-promo-bar"]) return;
  try {
    
  /* Promo bar text slider */
  var sliders = document.querySelectorAll('[data-promo-slider]');

  sliders.forEach(function(slider) {
    var slides = slider.querySelectorAll('.custom-promo-bar__slide');
    if (slides.length < 2) return;

    var current = 0;
    var speed = parseInt(slider.getAttribute('data-speed') || '4', 10) * 1000;
    var interval;

    function showSlide(index) {
      slides.forEach(function(slide, i) {
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      current = index;
    }

    function nextSlide() {
      showSlide((current + 1) % slides.length);
    }

    function prevSlide() {
      showSlide((current - 1 + slides.length) % slides.length);
    }

    function startAutoplay() {
      stopAutoplay();
      interval = setInterval(nextSlide, speed);
    }

    function stopAutoplay() {
      if (interval) clearInterval(interval);
    }

    var prevBtn = slider.querySelector('[data-promo-prev]');
    var nextBtn = slider.querySelector('[data-promo-next]');

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        prevSlide();
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        nextSlide();
        startAutoplay();
      });
    }

    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-reviews"] && !Shopify.designMode) return;
  try {
    
  /*
    custom-reviews-controller: rail buttons (Spotlight and rail) and the sort and
    chip controls (Full list). ASCII only: no text strings live here, because the
    localized status text arrives in data attributes.
  */
  class CustomReviewsController extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      var signal = this.abortController.signal;
      var rail = this.querySelector('[data-rail]');
      var rows = this.querySelector('[data-rows]');
      if (rail) {
        this.setupRail(rail, signal);
      }
      if (rows) {
        this.setupList(rows, signal);
      }
    }

    disconnectedCallback() {
      if (this.abortController) {
        this.abortController.abort();
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    }

    setupRail(rail, signal) {
      var nav = this.querySelector('[data-rail-nav]');
      var buttons = this.querySelectorAll('[data-rail-dir]');
      var prev = buttons[0];
      var next = buttons[1];

      var sync = function () {
        var fits = rail.scrollWidth <= rail.clientWidth + 4;
        if (nav) {
          nav.hidden = fits;
        }
        if (prev) {
          prev.disabled = rail.scrollLeft < 4;
        }
        if (next) {
          next.disabled = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 4;
        }
      };

      for (var i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener('click', function (event) {
          var button = event.currentTarget;
          var card = rail.firstElementChild;
          var step = card ? card.getBoundingClientRect().width + 16 : 300;
          rail.scrollBy({ left: step * Number(button.dataset.railDir), behavior: 'smooth' });
        }, { signal: signal });
      }

      rail.addEventListener('scroll', sync, { passive: true, signal: signal });
      window.addEventListener('load', sync, { once: true, signal: signal });
      if (typeof ResizeObserver === 'function') {
        // The observer runs sync() once as soon as it starts observing.
        this.resizeObserver = new ResizeObserver(sync);
        this.resizeObserver.observe(rail);
      } else {
        sync();
      }
    }

    setupList(rows, signal) {
      var ledger = this.querySelector('[data-status-many]');
      var status = this.querySelector('[data-status]');
      var select = this.querySelector('[data-sort]');
      var chips = this.querySelectorAll('[data-chip]');
      var activeType = 'all';

      var update = function () {
        var items = Array.prototype.slice.call(rows.children);
        var mode = select ? select.value : 'new';
        items.sort(function (a, b) {
          var dateA = a.dataset.date || '';
          var dateB = b.dataset.date || '';
          var ratingA = Number(a.dataset.rating) || 0;
          var ratingB = Number(b.dataset.rating) || 0;
          if (mode === 'high' && ratingA !== ratingB) {
            return ratingB - ratingA;
          }
          if (mode === 'low' && ratingA !== ratingB) {
            return ratingA - ratingB;
          }
          if (dateA === dateB) {
            return 0;
          }
          return dateA < dateB ? 1 : -1;
        });
        var visible = 0;
        for (var i = 0; i < items.length; i++) {
          var match = activeType === 'all' || items[i].dataset.type === activeType;
          items[i].hidden = !match;
          if (match) {
            visible += 1;
          }
          rows.appendChild(items[i]);
        }
        if (status && ledger) {
          var text = visible === 1 ? ledger.dataset.statusOne : ledger.dataset.statusMany.replace('#N#', String(visible));
          status.textContent = text;
        }
      };

      if (select) {
        select.addEventListener('change', update, { signal: signal });
      }
      for (var c = 0; c < chips.length; c++) {
        chips[c].addEventListener('click', function (event) {
          activeType = event.currentTarget.dataset.chip;
          for (var j = 0; j < chips.length; j++) {
            chips[j].setAttribute('aria-pressed', chips[j] === event.currentTarget ? 'true' : 'false');
          }
          update();
        }, { signal: signal });
      }
    }
  }

  if (!customElements.get('custom-reviews-controller')) {
    customElements.define('custom-reviews-controller', CustomReviewsController);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-testimonials"] && !Shopify.designMode) return;
  try {
    
  class CustomTestimonialsSlider extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('.custom-testimonials__track');
      this.dots = this.querySelectorAll('.custom-testimonials__dot');
      this.cards = this.querySelectorAll('.custom-testimonials__card');
      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.currentIndex = 0;
      this.autoplayTimer = null;

      if (!this.track || this.cards.length === 0) return;

      this.bindEvents();

      if (this.autoplay && !Shopify.designMode) {
        this.startAutoplay();
      }
    }

    bindEvents() {
      var self = this;

      // Dot clicks
      this.dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var index = parseInt(dot.dataset.index, 10);
          self.goTo(index);
          self.stopAutoplay();
        });
      });

      // Track scroll updates dots
      if (this.track) {
        this.track.addEventListener('scroll', function() {
          self.updateDotsFromScroll();
        }, { passive: true });
      }

      // Pause on hover/focus
      this.addEventListener('mouseenter', function() { self.stopAutoplay(); });
      this.addEventListener('mouseleave', function() {
        if (self.autoplay && !Shopify.designMode) self.startAutoplay();
      });
      this.addEventListener('focusin', function() { self.stopAutoplay(); });
      this.addEventListener('focusout', function() {
        if (self.autoplay && !Shopify.designMode) self.startAutoplay();
      });

      // Visibility observer -- pause when offscreen
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              if (self.autoplay && !Shopify.designMode) self.startAutoplay();
            } else {
              self.stopAutoplay();
            }
          });
        }, { threshold: 0.1 });
        observer.observe(this);
      }
    }

    goTo(index) {
      if (!this.cards[index]) return;
      this.currentIndex = index;
      this.cards[index].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      this.updateDots(index);
    }

    updateDots(index) {
      this.dots.forEach(function(dot, i) {
        dot.classList.toggle('active', i === index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }

    updateDotsFromScroll() {
      if (!this.track || this.cards.length === 0) return;
      var scrollLeft = this.track.scrollLeft;
      var cardWidth = this.cards[0].offsetWidth + 20; // gap
      var index = Math.round(scrollLeft / cardWidth);
      if (index !== this.currentIndex && index >= 0 && index < this.cards.length) {
        this.currentIndex = index;
        this.updateDots(index);
      }
    }

    startAutoplay() {
      var self = this;
      this.stopAutoplay();
      this.autoplayTimer = setInterval(function() {
        var next = self.currentIndex + 1;
        if (next >= self.cards.length) next = 0;
        self.goTo(next);
      }, this.speed);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  customElements.define('custom-testimonials-slider', CustomTestimonialsSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-timeline"] && !Shopify.designMode) return;
  try {
    
  function initCustomTimeline() {
    var blocks = document.querySelectorAll('.custom-timeline__entry');

    if ('IntersectionObserver' in window && !Shopify.designMode) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          var icon = entry.target.querySelector('.custom-timeline__icon');
          var content = entry.target.querySelector('.custom-timeline__content');

          if (entry.isIntersecting) {
            icon.classList.add('is-visible');
            content.classList.add('is-visible');
          } else {
            icon.classList.remove('is-visible');
            content.classList.remove('is-visible');
          }
        });
      }, {
        rootMargin: '0px 0px -50px 0px',
        threshold: 0
      });

      blocks.forEach(function(block) {
        observer.observe(block);
      });
    } else {
      blocks.forEach(function(block) {
        var icon = block.querySelector('.custom-timeline__icon');
        var content = block.querySelector('.custom-timeline__content');
        icon.classList.add('is-visible');
        content.classList.add('is-visible');
      });
    }
  }

  initCustomTimeline();

  document.addEventListener('shopify:section:load', initCustomTimeline);
  document.addEventListener('shopify:block:select', initCustomTimeline);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
